module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "id": "change-responsability"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.info && _vm.user) ? _c('div', {
    staticClass: "text-center big-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.info.changeable.length))]), (_vm.info.changeable.length > 1) ? _c('span', [_vm._v(" contatos terão sua responsabilidade")]) : _c('span', [_vm._v(" contato terá sua responsabilidade")]), _c('br'), _c('span', [_vm._v("transferida para")]), _c('strong', [_vm._v(" " + _vm._s(_vm.user.firstAndLastName()))]), _c('div', {
    staticClass: "small-text"
  }, _vm._l((_vm.info.users), function(user) {
    return _c('div', {
      staticClass: "user_contacts"
    }, [_c('strong', [_vm._v(_vm._s(user.count))]), (user.count > 1) ? _c('span', [_vm._v(" contatos de")]) : _c('span', [_vm._v(" contato de")]), _c('strong', [_vm._v(" " + _vm._s(user.name))])])
  }), 0), (_vm.info.unfinished.length > 0) ? _c('div', {
    staticClass: "warning"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Atenção:")]), (_vm.info.unfinished.length > 1) ? _c('span', [_vm._v(" existem " + _vm._s(_vm.info.unfinished.length) + " contatos não finalizados.")]) : _c('span', [_vm._v(" existe " + _vm._s(_vm.info.unfinished.length) + " contato não finalizado.")]), _c('br'), (_vm.info.unfinished.length > 1) ? _c('span', [_vm._v("Eles precisam ser finalizados antes de transferidos.")]) : _c('span', [_vm._v("Ele precisa ser finalizado antes de transferido.")])]) : _vm._e()]) : _vm._e()]), (_vm.info) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-gray",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.reject
    }
  }, [_vm._v("Cancelar")]), (_vm.info.unfinished.length > 0) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.confirm(true)
      }
    }
  }, [_vm._v("Finalizar e transferir")]) : _vm._e(), (_vm.info.unfinished.length > 0) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirm(false)
      }
    }
  }, [_vm._v("Transferir só finalizados")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirm(false)
      }
    }
  }, [_vm._v("Transferir")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Alterar responsável")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a0780b3!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contacts/change_responsability_modal.vue
// module id = 1052
// module chunks = 1